<p-blockUI [blocked]="loading">
    <p-progressSpinner ariaLabel="Loading.." />
</p-blockUI>